import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';

export class ChestJump extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const anticipation1Tween = this.getTween(transform.scale);
        const anticipation2Tween = this.getTween(transform.scale);
        const anticipation3Tween = this.getTween(transform.scale);

        const jumpTween = this.getTween(transform.position);
        const fallTween = this.getTween(transform.position);

        anticipation1Tween.to({ y: 0.5 }, 100);
        anticipation2Tween.to({ x: 1.2, y: 1.2 }, 100);
        anticipation3Tween
            .to({ x: 1.0, y: 1.0 }, 600)
            .easing(Easing.Bounce.Out);

        anticipation1Tween.chain(anticipation2Tween);
        anticipation2Tween.chain(anticipation3Tween);
        anticipation3Tween.chain(anticipation1Tween);

        jumpTween.to({ y: -30.0 }, 400).easing(Easing.Quadratic.Out);
        fallTween.to({ y: 0 }, 600).easing(Easing.Bounce.Out);

        jumpTween.chain(fallTween);
        fallTween.chain(jumpTween);

        anticipation1Tween.delay(1400).start(this.elapsedTime);
        anticipation3Tween.delay(300);

        jumpTween.delay(1500).start(this.elapsedTime);

        while (true) yield;
    }
}
